import { Component, inject } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { environment } from '../../../../environments/environment';
import { NoticeBoard } from '../../../core/service/notice/notice.service';
import { LoaderService } from '../../../core/service/loader.service';

interface NoticeData {
  description: string;
  imagePath: string;
  noticeid: string;
  title: string;
  count: number;
  universityCountryDetails:any;
  universityName:any;
  intakeDetails:any
}

@Component({
  selector: 'app-notice-popup-admin',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './notice-popup-admin.component.html',
  styleUrl: './notice-popup-admin.component.scss'
})
export class NoticePopupAdminComponent {
  public readonly loader = inject(LoaderService)
  fileUrl = environment?.fileBaseUrl
  readonly data = inject<NoticeData>(MAT_DIALOG_DATA);
  private readonly noticeBoard =inject(NoticeBoard)
  readonly dialogRef = inject(MatDialogRef<NoticePopupAdminComponent>)

  ngOnInit(){
    console.log(this.data,'data')
  }

  markAsRead(){
    this.loader.show()
    const payload = { 
       "isRead": "true"
    };
    this.noticeBoard.putSeenNotice(this.data?.noticeid,payload).subscribe(
      (res)=>{
        this.loader.hide()
        this.dialogRef.close('marked');
      }
    )
    this.loader.hide()
    this.dialogRef.close();
  }


}
